module.exports = __webpack_public_path__ + "img/huiyuan.9d252250.png";